import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  class: "thumb-up_svg__svg-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M17.002 3.546 14.999 9H21.5c1 3.49.492 7.693-1.498 11H9.001L8.999 9 15 2.05c.989-.246 2 .444 2 1.496ZM7 9.03H2V21h5V9.03Z"
    }, null, -1)
  ]))]))
}
export default { render: render }